import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as fromDisputeRequest from '../dispute/DisputeRequest';
import { ServiceProviderService } from '../services/service-provider.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-dispute',
  templateUrl: './dispute.component.html',
  styleUrls: ['./dispute.component.css'],
})

export class DisputeComponent implements OnInit {
  showError: boolean = false;
  textMsg: any;
  invoiceData: any;
  itemData: any;
  itemCADocumentNumber: any;
  invoiceStatus: any;
  disputeForm!: FormGroup;
  isMasterSel: boolean;
  amount: any = 0.00;
  currency!: string;
  iId!: string;
  itemNumber: string = "0";
  disputeInvoiceLevel: boolean = true;
  bpNo: any;
  flag: boolean;
  type: any;
  section1: boolean = true;
  section2: boolean = false;
  dr: any;
  showLoader: boolean = false;
  submitted: boolean = false;
  infovalue: any = 20;
  summaryvalue: any = 0;
  confirmvalue: any = 0;
  message: any;
  DisputeTypeMap!: Map<String, String>;
  selectedReason: string | undefined;
  DisputeReasonMap!: Map<String, String>;
  DisputePriority!: Map<String, String>;
  selectedPriority!: string;
  selectedDisputeType!: string;
  formData: FormData = new FormData();
  fileName: String = "";

  constructor(
    private modalService: NgbModal, 
    private fb: FormBuilder, 
    private http: HttpClient,
    private spService: ServiceProviderService, 
    private router: Router, 
    private route: ActivatedRoute
  ) {
    this.flag = true;
    this.isMasterSel = false;
  }

  ngOnInit(): void {
    this.getDisputeConfig();
    this.type = history.state.type;

    if (this.type == "invoice") {
      this.invoiceData = history.state.invoice;
      this.iId = this.invoiceData.invoice_id;
      this.amount = parseFloat(this.invoiceData.amount).toFixed(2);
      this.currency = this.invoiceData.currency;
    } else if (this.type == "item") {
      this.invoiceData = history.state.invoice;
      this.itemData = history.state.item;
      this.itemNumber = this.itemData.itemNo
      this.iId = this.invoiceData.invoice_id
      this.amount = parseFloat(this.itemData.itemCAAmountInTransactionCurrency).toFixed(2);
      this.currency = this.itemData.itemTransactionCurrency;
      this.disputeInvoiceLevel = false;
    }

    this.disputeForm = this.fb.group({
      amount: new FormControl(0.00, Validators.required),
      type: new FormControl('', Validators.required),
      priority: new FormControl('', Validators.required),
      reason: new FormControl('', Validators.required),
      note: new FormControl('', Validators.required),
      iNumber: new FormControl(this.iId, Validators.required),
      itemNumber: ''
    });

    this.disputeForm.get('type')?.valueChanges.subscribe((val: any) => {
      this.infovalue = this.infovalue + 10;
    });
    this.disputeForm.get('priority')?.valueChanges.subscribe((val: any) => {
      this.infovalue = this.infovalue + 10;
    });
    this.disputeForm.get('reason')?.valueChanges.subscribe((val: any) => {
      this.infovalue = this.infovalue + 10;
    });
    this.disputeForm.get('amount')?.valueChanges.subscribe((val: any) => {
      this.infovalue = this.infovalue + 20;
    });
    this.disputeForm.get('note')?.valueChanges.subscribe((val: any) => {
      this.infovalue = this.infovalue + 20;
    });
  }

  get f(): { [key: string]: AbstractControl } {
    console.log("callerd")
    return this.disputeForm.controls;
  }

  getDisputeConfig() {
    this.spService.getDisputeConfig().subscribe((res: any) => {
      this.DisputeTypeMap = res.disputeTypeMap;
      this.DisputeReasonMap = res.disputeReasonMap;
      this.DisputePriority = res.disputePriorityMap;
    })
  }

  submitDisputeForm() {
    this.summaryvalue = this.summaryvalue + 30;
    console.log(this.disputeForm.value);
    let inv = this.invoiceData;
    this.dr = new fromDisputeRequest.DisputeRequest();
    let drCaseObject = new fromDisputeRequest.DisputeCaseObject();
    this.dr.BusinessPartner = this.invoiceData.bpNo;
    this.dr.CADisputeExternalCallerCode = "EXT";
    this.dr.CADisputeType = this.disputeForm.get("type")?.value;
    this.dr.CasePriority = this.disputeForm.get("priority")?.value;
    this.dr.CaseReason = this.disputeForm.get("reason")?.value;
    this.dr.ContractAccount = inv.caContract;
    this.dr.DisputeCaseCurrency = inv.currency;
    this.dr.InvoiceNumber = inv.invoice_id;
    this.dr.DisputedAmount = parseFloat(this.disputeForm.get("amount")?.value);
    this.amount = this.dr.DisputedAmount;
    this.dr.CaseNoteText = this.disputeForm.get("note")?.value;
    drCaseObject.ObjectKey = this.itemCADocumentNumber;
    drCaseObject.ObjectType = "CA_DOC";
    this.dr._CACaseObject.push(drCaseObject);
    this.summaryvalue = this.summaryvalue + 30;;
  }

  createDispute(content: any) {
    this.summaryvalue = this.summaryvalue + 20;
    this.confirmvalue = this.confirmvalue + 50;
    this.showLoader = true;
    this.message = "Creating Your Dispute"
    this.textMsg = "We are creating your dispute. Please wait for sometime.";
    this.modalService.open(content);
    this.spService.createDispute(this.dr).subscribe((res: any) => {
      this.showLoader = false;
      this.showError = false;
      let headers = new HttpHeaders()
      .set('Content-Type', 'multipart/form-data')
      .set('Accept', 'application/json');
      let logTraceJSON: any = { 'eventSource': 'uploadDisputeAttachment', 'payload': this.formData, 'ban': this.invoiceData ? this.invoiceData.bpNo : '', 'contractAccount': this.invoiceData.caContract };
      headers = headers.set('X-Log-Trace', JSON.stringify(logTraceJSON));
      let options = { headers: headers };
      if (this.fileName != "") {
        this.http.post(environment.serverURL + environment.brimURI + 'dispute/attachment/' + res.caseUUID, this.formData, options)
          .subscribe(
            (res1: any) => {
              console.log(res1);
              this.message = "Dispute Successfully Created!";
              this.textMsg = "Dispute ID :" + res.caseUUID + " has been created successfully.";
              this.confirmvalue = this.confirmvalue + 50;
            },
            (err: any) => {
              this.showError = true;
              this.message = "Error!";
              this.textMsg = "Something went wrong while uploading attachment, please try to upload it <a href='./view-my-dispute'>View My Dispute<a> screen.";
              console.log(err.message);
            }
          );
      } else {
        this.showLoader = false;
        this.showError = false;
        this.message = "Dispute Successfully Created!";
        this.textMsg = "Dispute ID :" + res.caseUUID + " has been created successfully.";
        this.confirmvalue = this.confirmvalue + 50;
      }
    },
      (err: any) => {
        console.log("In error" + err);
        this.showError = true;
        this.message = "Network Error!";
        this.textMsg = "Something is temporarily wrong, please try again after sometime or contact to our support team.";
      }
    );
  }

  closeDisputePopup() {
    this.modalService.dismissAll();
    this.confirmvalue = this.confirmvalue + 20;
    this.router.navigate(["view-my-dispute"], { relativeTo: this.route.parent });
  }

  saveDispute() {
    this.submitted = true;
    console.log(this.disputeForm.invalid)
    if (this.disputeForm.invalid) {
      console.log(this.disputeForm.invalid)
      return;
    }
    this.section1 = false
    this.section2 = true;
    this.summaryvalue = this.summaryvalue + 20;
    this.submitDisputeForm();
  }

  editdispute() {
    this.infovalue = 80;
    this.summaryvalue = 0;
    this.confirmvalue = 0;
    this.section2 = false
    this.section1 = true;
  }

  selectReason(reason: any, value: any): void {
    this.disputeForm.get('reason')?.setValue(value);
    this.selectedReason = reason;
  }

  selectPriority(priority: any, value: any): void {
    this.disputeForm.get('priority')?.setValue(value);
    this.selectedPriority = priority;
  }

  selectDisputeType(type: any, value: any): void {
    this.disputeForm.get('type')?.setValue(value);
    this.selectedDisputeType = type;
  }

  fileChange(event: any) {
    let fileList: FileList = event.target.files;
    if (fileList.length < 1) {
      return;
    }
    let file: File = fileList[0];
    this.formData.append('file', file, file.name)
    this.fileName = file.name;
  }
}